// Test IDs for The Bookshelf Project — Impact Map.

export const NAV = {
  brandLink: "nav-brand-link",
  homeLink: "nav-home-link",
  registerLink: "nav-register-link",
  adminLink: "nav-admin-link",
  mobileToggle: "nav-mobile-toggle",
};

export const LANDING = {
  heroCtaRegister: "landing-hero-register-cta",
  heroCtaLearn: "landing-hero-learn-cta",
  counterInstalled: "landing-counter-installed",
  counterFamilies: "landing-counter-families",
  counterNeighborhoods: "landing-counter-neighborhoods",
  counterChildren: "landing-counter-children",
  mapSection: "landing-map-section",
  accessibleTableToggle: "landing-accessible-table-toggle",
  accessibleTable: "landing-accessible-table",
};

export const MAP = {
  container: "impact-map-container",
  filterPanel: "impact-map-filter-panel",
  toggleLayerPending: "map-toggle-layer-pending",
  toggleLayerScheduled: "map-toggle-layer-scheduled",
  toggleLayerActive: "map-toggle-layer-active",
  filterJurisdiction: "map-filter-jurisdiction",
  filterWard: "map-filter-ward",
  searchNeighborhood: "map-search-neighborhood",
  filterDateFrom: "map-filter-date-from",
  filterDateTo: "map-filter-date-to",
  toggleHeatmap: "map-toggle-heatmap",
  clearFiltersBtn: "map-clear-filters-btn",
};

export const REGISTRATION = {
  firstName: "registration-first-name",
  lastName: "registration-last-name",
  email: "registration-email",
  phone: "registration-phone",
  address: "registration-address",
  neighborhood: "registration-neighborhood",
  ward: "registration-ward",
  jurisdiction: "registration-jurisdiction",
  numChildren: "registration-num-children",
  familyQuote: "registration-family-quote",
  lat: "registration-lat",
  lng: "registration-lng",
  submit: "registration-submit-btn",
  successCard: "registration-success-card",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logoutButton: "admin-logout-button",
  metricRegistered: "admin-metric-registered",
  metricInstalled: "admin-metric-installed",
  metricPending: "admin-metric-pending",
  metricNewMonth: "admin-metric-new-month",
  familyTable: "admin-family-table",
  familyRow: "admin-family-row",
  rowCheckbox: "admin-family-row-checkbox",
  selectAllCheckbox: "admin-family-select-all",
  bulkStatusSelect: "admin-bulk-status-select",
  bulkStatusApply: "admin-bulk-status-apply",
  exportCsvButton: "admin-export-csv-button",
  statusSelect: "admin-row-status-select",
  searchInput: "admin-search-input",
  filterStatus: "admin-filter-status",
  filterJurisdiction: "admin-filter-jurisdiction",
};

export const LOGIN = {
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  submitButton: "login-submit-button",
};

export const HOME = { emergentLink: "home-emergent-link" };
